import { activeDialsName } from "../utils/devDials";

// Unmissable marker that this session is running a probe dial cell rather than
// stock defaults. Renders nothing in production and nothing when no cell is
// active, so the normal app is untouched.
//
// Deliberately loud and deliberately fixed to the viewport: the whole point is
// that a hand-played feel pass can never be mistaken for a stock draft, either
// live or in a screenshot of one.
export default function DevDialsBadge() {
  const name = activeDialsName();
  if (!name) return null;
  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: "fixed", bottom: 10, left: 10, zIndex: 99999,
        background: "#b91c1c", color: "#fff",
        font: "700 11px/1.2 ui-monospace, SFMono-Regular, Menlo, monospace",
        letterSpacing: "0.06em", padding: "6px 10px", borderRadius: 4,
        border: "1px solid #fca5a5", boxShadow: "0 2px 10px rgba(0,0,0,0.45)",
        pointerEvents: "none", textTransform: "uppercase",
      }}
    >
      DIALS: {name}
    </div>
  );
}
